import React, { useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
import { GeoJSON, useLeaflet, Polyline } from 'react-leaflet';
import { useStoreState, useStoreActions } from 'easy-peasy';
import theme from '~/scripts/theme';

const OutlineGeoJSON = styled(GeoJSON)`
  stroke-width: 1;
  stroke: #ddd;
  fill: none;
`;

const StatesGeoJSON = styled(GeoJSON)`
  fill: none;
  stroke: #777;
  stroke-width: 1;
`;

const DrawLine = () => {
  const drawCoords = useStoreState((state) => state.app.drawCoords);
  return (
    <Polyline
      positions={drawCoords}
      color={theme.colors.scissor}
      lineCap="round"
      lineJoin="round"
      dashArray="6,13"
    />
  );
};

const Draw = ({ outline, states }) => {
  const { map } = useLeaflet();
  const isDrawing = useStoreState((state) => state.app.isDrawing);
  const drawEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  const showDrawEnableOverlay = useStoreState(
    (state) => state.app.showDrawEnableOverlay
  );
  const setDrawing = useStoreActions((actions) => actions.app.setDrawing);
  const addDrawCoord = useStoreActions((actions) => actions.app.addDrawCoord);
  const resetDrawCoords = useStoreActions(
    (actions) => actions.app.resetDrawCoords
  );
  const finishDrawing = useStoreActions((actions) => actions.app.finishDrawing);

  const isDrawingEnabled = !showDrawEnableOverlay && drawEnabled;

  const handleMouseDown = useCallback(
    (evt) => {
      if (isDrawingEnabled) {
        resetDrawCoords();
        setDrawing(true);
      }
    },
    [isDrawingEnabled]
  );

  const handleMouseMove = useCallback(
    (evt) => {
      evt.originalEvent.preventDefault();
      if (isDrawing) {
        addDrawCoord(evt.latlng);
      }
    },
    [isDrawing]
  );

  const handleMouseUp = useCallback(
    (evt) => {
      if (isDrawing) {
        setDrawing(false);
        finishDrawing();
      }
    },
    [isDrawing]
  );

  if (map && map.tap) {
    if (isDrawingEnabled) {
      map.tap.enable();
    } else {
      map.tap.disable();
    }
  }

  useEffect(() => {
    map.on('mousedown', handleMouseDown);
    map.on('mousemove', handleMouseMove);
    map.on('mouseup', handleMouseUp);
    map.getContainer().addEventListener('mouseleave', handleMouseUp);

    return () => {
      map.off('mousedown', handleMouseDown);
      map.off('mousemove', handleMouseMove);
      map.off('mouseup', handleMouseUp);
      map.getContainer().removeEventListener('mouseleave', handleMouseUp);
    };
  }, [isDrawing, isDrawingEnabled]);

  return (
    <>
      {isDrawingEnabled && (
        <>
          {/* <OutlineGeoJSON data={outline} /> */}
          <StatesGeoJSON data={states} />
        </>
      )}
      <DrawLine />
    </>
  );
};

export default Draw;
